import { useFormContext } from "react-hook-form";
import { FieldConfig } from "../formConfig";
import TextField from "./fields/TextField";
import TextAreaField from "./fields/TextAreaField";
import DateField from "./fields/DateField";
import RadioField from "./fields/RadioField";
import CheckboxField from "./fields/CheckboxField";
import LikertField from "./fields/LikertField";
import FileField from "./fields/FileField";
import PersonField from "./fields/PersonField";
import CurrencyField from "./fields/CurrencyField";
import AddressField from "./fields/AddressField";

export default function FieldRenderer({ field }: { field: FieldConfig }) {
  const { formState } = useFormContext();
  const error = (formState.errors as Record<string, { message?: string } | undefined>)[field.id];

  let control: React.ReactNode = null;
  switch (field.type) {
    case "text_no_input":
      return (
        <section className="static-form-text" aria-labelledby={`${field.id}-heading`}>
          {field.question && <h3 id={`${field.id}-heading`}>{field.question}</h3>}
          {field.displayText && <div className="static-form-text-body">{field.displayText}</div>}
        </section>
      );
    case "file_no_input":
      return (
        <section className="static-form-file" aria-labelledby={`${field.id}-heading`}>
          {field.question && <h3 id={`${field.id}-heading`}>{field.question}</h3>}
          {field.hint && <div className="hint">{field.hint}</div>}
          {field.attachment ? (
            <a className="static-file-link" href={`/api/download?url=${encodeURIComponent(field.attachment.url)}`} target="_blank" rel="noreferrer">
              {field.attachment.name}
            </a>
          ) : (
            <div className="hint">No file has been added yet.</div>
          )}
        </section>
      );
    case "text": control = <TextField field={field} />; break;
    case "email": control = <TextField field={field} type="email" />; break;
    case "textarea": control = <TextAreaField field={field} />; break;
    case "date": control = <DateField field={field} />; break;
    case "radio": control = <RadioField field={field} />; break;
    case "radio_vertical": control = <RadioField field={field} vertical />; break;
    case "checkbox": control = <CheckboxField field={field} />; break;
    case "checkbox_vertical": control = <CheckboxField field={field} vertical />; break;
    case "likert": control = <LikertField field={field} />; break;
    case "file": control = <FileField field={field} />; break;
    case "person": control = <PersonField field={field} />; break;
    case "currency": control = <CurrencyField field={field} />; break;
    case "address": control = <AddressField field={field} />; break;
  }

  return (
    <div className="field">
      <label className="q">
        {field.question} {field.required && <span className="required">*</span>}
      </label>
      {field.hint && <div className="hint">{field.hint}</div>}
      {control}
      {error?.message && <div className="error">{error.message}</div>}
    </div>
  );
}
